import type { EmailServicePreviewPayload, EmailServiceSubmitFormRequest } from 'apiConnector/email-service';
import type { EmailServiceDocument } from 'models/emailService/EmailServiceDocument';
import type { EmailServiceRecipient } from 'models/emailService/EmailServiceRecipient';
import type { NextWorkflowError } from 'models/NextWorkflowError';

import * as actionTypes from './emailService.actionTypes';
export type EmailServiceActions = ModalActions | FormActions;

type ModalActions = EmailServiceModalOpened | EmailServiceModalClosed;

type FormActions =
  | EmailServiceRecipientChanged
  | EmailServiceDocumentsChanged
  | EmailServicePreviewContentReceived
  | EmailServicePreviewContentFailed
  | EmailServiceDocumentsChanged
  | EmailServiceFormSubmissionRequested
  | EmailServiceFormSubmissionFailed
  | EmailServiceFormSubmitted;

export function emailServiceModalOpened() {
  return {
    type: actionTypes.EMAIL_SERVICE_MODAL_OPENED,
  };
}
export type EmailServiceModalOpened = ReturnType<typeof emailServiceModalOpened>;

export function emailServiceModalClosed() {
  return {
    type: actionTypes.EMAIL_SERVICE_MODAL_CLOSED,
  };
}
export type EmailServiceModalClosed = ReturnType<typeof emailServiceModalClosed>;

export function emailServicePreviewContentReceived(value: EmailServicePreviewPayload) {
  return {
    type: actionTypes.EMAIL_SERVICE_PREVIEW_CONTENT_RECEIVED,
    value,
  };
}
export type EmailServicePreviewContentReceived = ReturnType<typeof emailServicePreviewContentReceived>;

export function emailServicePreviewContentFailed(errors: readonly NextWorkflowError[] = []) {
  return {
    type: actionTypes.EMAIL_SERVICE_PREVIEW_CONTENT_FAILED,
    value: errors,
  };
}
export type EmailServicePreviewContentFailed = ReturnType<typeof emailServicePreviewContentFailed>;

export function emailServiceRecipientChanged(value: EmailServiceRecipient) {
  return {
    type: actionTypes.EMAIL_SERVICE_RECIPIENT_CHANGED,
    value,
  };
}
export type EmailServiceRecipientChanged = ReturnType<typeof emailServiceRecipientChanged>;

export function emailServiceDocumentsChanged(value: readonly EmailServiceDocument[]) {
  return {
    type: actionTypes.EMAIL_SERVICE_DOCUMENTS_CHANGED,
    value,
  };
}
export type EmailServiceDocumentsChanged = ReturnType<typeof emailServiceDocumentsChanged>;

export function emailServiceFormSubmissionRequested(tradeId: string, request: EmailServiceSubmitFormRequest) {
  return {
    type: actionTypes.EMAIL_SERVICE_FORM_SUBMISSION_REQUESTED,
    request,
    tradeId,
  };
}
export type EmailServiceFormSubmissionRequested = ReturnType<typeof emailServiceFormSubmissionRequested>;

export function emailServiceFormSubmissionFailed(errors: readonly string[]) {
  return {
    type: actionTypes.EMAIL_SERVICE_FORM_SUBMISSION_FAILED,
    errors: errors,
  };
}
export type EmailServiceFormSubmissionFailed = ReturnType<typeof emailServiceFormSubmissionFailed>;

export function emailServiceFormSubmitted(warnings: readonly string[]) {
  return {
    type: actionTypes.EMAIL_SERVICE_FORM_SUBMITTED,
    warnings: warnings,
  };
}
export type EmailServiceFormSubmitted = ReturnType<typeof emailServiceFormSubmitted>;
